// extracted by mini-css-extract-plugin
module.exports = {"LoadContainer":"LoadingScreen-module--LoadContainer--AmDzh"};